// Services & Transport data for Bellagio — taxis, public transport, experiences
export const TAXIS = [
  { name: "Stefano", phone: "+39 334 7835254", tel: "+393347835254" },
  { name: "Nicola", phone: "+39 329 7032702", tel: "+393297032702" },
  { name: "Christian", phone: "+39 328 0649328", tel: "+393280649328" },
  { name: "Corrado", phone: "+39 338 2924212", tel: "+393382924212" },
  { name: "Evening Taxi Service", phone: "+39 333 8235536", tel: "+393338235536",
    note: { it: "Solo sera", en: "Evening only", fr: "Le soir uniquement" } },
  { name: "Fabio", phone: "+39 339 3887238", tel: "+393393887238" },
  { name: "Marco L.", phone: "+39 347 4845905", tel: "+393474845905" },
  { name: "Marco B.", phone: "+39 338 3580818", tel: "+393383580818" },
];

export const PUBLIC_TRANSPORT = [
  {
    name: "Navigazione Laghi",
    url: "https://www.navigazionelaghi.it/biglietti-e-orari-lago-di-como/",
    desc: {
      it: "Battelli e traghetti sul Lago di Como — orari e biglietti ufficiali per Varenna, Menaggio, Tremezzo e Como.",
      en: "Boats and ferries on Lake Como — official timetables and tickets for Varenna, Menaggio, Tremezzo and Como.",
      fr: "Bateaux et ferries sur le lac de Côme — horaires et billets officiels pour Varenna, Menaggio, Tremezzo et Côme.",
    },
  },
  {
    name: "ASF Autolinee",
    url: "https://www.asfautolinee.it/orari-in-pdf/",
    desc: {
      it: "Autobus di linea da e per Bellagio, Como e i borghi del lago. Orari scaricabili in PDF.",
      en: "Bus lines to and from Bellagio, Como and the lake villages. Downloadable PDF timetables.",
      fr: "Lignes de bus depuis et vers Bellagio, Côme et les villages du lac. Horaires en PDF.",
    },
  },
];

export const EXPERIENCES = [
  {
    name: "Jungle Raider Park",
    area: "Civenna",
    url: "https://www.jungleraiderpark.com",
    images: [
      "/assets/o8tbzozb_home-parco-avventura-xtreme.avif",
      "/assets/9i5elkez_header8.avif",
    ],
    desc: {
      it: "Parco avventura sugli alberi sopra Bellagio (Civenna): percorsi acrobatici, tirolesi panoramiche e ponti tibetani per grandi e piccoli (dai 3 anni).",
      en: "Treetop adventure park above Bellagio (Civenna): acrobatic trails, panoramic zip-lines and rope bridges for kids and adults (from age 3).",
      fr: "Parc aventure dans les arbres au-dessus de Bellagio (Civenna) : parcours acrobatiques, tyroliennes panoramiques et ponts de singe pour petits et grands (dès 3 ans).",
    },
  },
  {
    name: "Giardini di Villa Melzi",
    area: "Bellagio",
    url: "https://www.giardinidivillamelzi.it",
    images: [
      "/assets/fr51swu0_20200507_221301.jpg",
    ],
    desc: {
      it: "Splendidi giardini all'inglese in riva al lago a Bellagio, con statue, piante esotiche e scorci incantevoli.",
      en: "Beautiful English-style lakeside gardens in Bellagio, with statues, exotic plants and enchanting views.",
      fr: "Magnifiques jardins à l'anglaise au bord du lac à Bellagio, avec statues, plantes exotiques et vues enchanteresses.",
    },
  },
  {
    name: "Villa del Balbianello",
    area: "Lenno · Tremezzina",
    url: "https://fondoambiente.it/luoghi/villa-del-balbianello",
    boat: true,
    images: [
      "/assets/mve77k5e_Sito-web1.avif",
    ],
    desc: {
      it: "Villa storica del FAI a Lenno (Tremezzina), sulla sponda opposta del lago: si raggiunge comodamente in barca o taxi acquatico. Celebre per i giardini terrazzati e le scene di film famosi.",
      en: "Historic FAI villa in Lenno (Tremezzina), on the opposite shore of the lake: easily reached by boat or water taxi. Famous for its terraced gardens and iconic film scenes.",
      fr: "Villa historique du FAI à Lenno (Tremezzina), sur la rive opposée du lac : facilement accessible en bateau ou taxi aquatique. Célèbre pour ses jardins en terrasses et ses scènes de films.",
    },
  },
  {
    name: "Como Lake Drive",
    area: "Lago di Como",
    url: "https://www.comolakedrive.com",
    car: true,
    images: [],
    desc: {
      it: "Servizio NCC (noleggio con conducente): taxi e transfer privati su strada da e per aeroporti, stazioni e per tour del territorio. Comfort, discrezione e puntualità.",
      en: "NCC private-driver service: taxis and private road transfers to and from airports, stations and for local tours. Comfort, discretion and punctuality.",
      fr: "Service NCC (voiture avec chauffeur) : taxis et transferts privés par la route depuis/vers aéroports, gares et pour des tours de la région. Confort, discrétion et ponctualité.",
    },
  },
];
